import R, { SemanticType as a } from "../MetaModel.js";
import { c as i, b as o, F as d } from "../filters-Cwo0Aj2k.js";
import "dayjs";
import { A as f, R as C, t as m } from "../period-BbmcGyLd.js";
import "react";
import { l as N } from "../lodash-DeBCDn4U.js";
import { LanguageResolver as A } from "@biron-data/react-contexts";
const p = "view1", S = "view1alias", T = "view2", I = "view2alias", e = {
  code: "dimensionCode1",
  alias: "dimensionAlias1",
  description: "dimensionDescription1",
  "@type": "simple",
  dictionaryCode: "dictionaryCode1",
  viewCodes: [p],
  asSimple: !0,
  semanticType: a.STRING
}, V = {
  code: "dimensionCode2",
  alias: "dimensionAlias2",
  description: "dimensionDescription2",
  "@type": "simple",
  dictionaryCode: "dictionaryCode2",
  viewCodes: [p],
  asSimple: !0,
  semanticType: a.DATE
}, g = {
  code: "dimensionCode3",
  alias: "dimensionAlias3",
  description: "dimensionDescription3",
  "@type": "simple",
  dictionaryCode: "dictionaryCode3",
  viewCodes: [T],
  asSimple: !0,
  semanticType: a.STRING
}, r = {
  code: "metricCode1",
  alias: "metricAlias1",
  description: "metricDescription1",
  expression: "",
  formatPrefix: "",
  formatSuffix: "",
  formatPrecision: 1,
  asRatio: !1
}, c = {
  code: "metricCode2",
  alias: "metricAlias2",
  description: "metricDescription2",
  expression: "",
  formatPrefix: "",
  formatSuffix: "",
  formatPrecision: 1,
  asRatio: !1
}, w = {
  code: "metricCode3",
  alias: "metricAlias3",
  description: "metricDescription3",
  expression: "",
  formatPrefix: "",
  formatSuffix: "",
  formatPrecision: 1,
  asRatio: !1
}, x = {
  metricCode: "metricCode1",
  metricAlias: "metricAlias1",
  having: void 0,
  viewAlias: "viewAlias",
  viewCode: "viewCode",
  additionalFilters: [],
  titlePartOverrides: {}
}, l = [
  {
    alias: S,
    code: p,
    description: "",
    dimensions: [e, V],
    metrics: [r],
    tableName: "20220920041634938_view_1"
  },
  {
    alias: I,
    code: T,
    description: "",
    dimensions: [g],
    metrics: [c, w],
    tableName: "20220920041634938_view_2"
  }
], b = {
  type: i.metric,
  metricCode: r.code,
  dataType: a.NUMBER,
  isValid: !0,
  reference: {
    id: r.alias,
    alias: r.alias,
    code: r.code,
    description: r.description
  },
  predicate: {
    negate: !1,
    operator: o.BETWEEN,
    value: {
      "@type": i.RANGE,
      maxInclusive: 2,
      minInclusive: 1
    }
  }
}, W = {
  type: i.metric,
  metricCode: c.code,
  dataType: a.NUMBER,
  isValid: !0,
  reference: {
    id: c.alias,
    alias: c.alias,
    code: c.code,
    description: c.description
  },
  predicate: {
    negate: !1,
    operator: o.BETWEEN,
    value: {
      "@type": i.RANGE,
      maxInclusive: 2,
      minInclusive: 1
    }
  }
}, B = new R(l), O = [{
  code: l[0].code,
  alias: l[0].alias,
  metrics: [r],
  tableName: "",
  description: "",
  dimensions: []
}], U = {
  growth: void 0,
  viewAlias: "viewAlias",
  viewCode: "viewCode",
  metricAlias: "metricAlias",
  metricCode: "metricCode",
  additionalFilters: [],
  titlePartOverrides: {}
}, n = [1, 2, 3, 4, 5, 6, 7, 8, 9].map((t) => ({
  "@type": "simple",
  viewCodes: ["viewCode"],
  dictionaryCode: `dictionaryCode${t > 1 ? t : ""}`,
  asSimple: !1,
  code: `dimensionCode${t > 1 ? t : ""}`,
  alias: `alias${t > 1 ? t : ""}`,
  description: "",
  semanticType: a.STRING
}));
var y, u;
const h = {
  type: i.dimension,
  dimensionCode: n[0].code,
  predicate: {
    negate: !1,
    operator: o.IN,
    value: {
      "@type": i.DICT_ENTRIES,
      entries: [{
        id: "entry"
      }]
    }
  },
  reference: {
    code: n[0].code,
    alias: n[0].alias,
    description: (y = n[0]) == null ? void 0 : y.description,
    dictionaryCode: (u = n[0]) == null ? void 0 : u.dictionaryCode
  },
  dataType: a.STRING,
  isValid: !0
}, k = {
  type: i.dimension,
  dataType: a.STRING,
  dimensionCode: n[0].code,
  reference: {
    id: "id",
    alias: "alias",
    code: "code"
  },
  predicate: {
    negate: !1,
    operator: o.Like,
    value: {
      "@type": i.PATTERN,
      pattern: "%baseValue",
      caseSensitive: !1
    }
  },
  isValid: !0
}, Q = {
  type: i.dimension,
  dataType: a.STRING,
  dimensionCode: n[0].code,
  reference: {
    id: "id",
    alias: "alias",
    code: "code"
  },
  predicate: {
    negate: !1,
    operator: o.Match,
    value: {
      "@type": i.PATTERN,
      pattern: "baseValue",
      caseSensitive: !1
    }
  },
  isValid: !0
}, H = {
  type: i.dimension,
  dataType: a.STRING,
  dimensionCode: n[0].code,
  reference: {
    id: "id",
    alias: "alias",
    code: "code"
  },
  predicate: {
    negate: !1,
    operator: o.IN,
    value: {
      "@type": i.DICT_ENTRIES,
      entries: [
        { id: "id" }
      ]
    }
  },
  isValid: !0
}, $ = {
  code: "dynamicPeriod",
  id: 678,
  end: "end",
  start: "start",
  type: f.fixed,
  position: 89,
  nameEN: "nameEN",
  nameFR: "nameFR",
  category: C.MONTH
}, j = {
  [d.REGEX]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.STRING,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.Match,
      value: {
        "@type": i.PATTERN,
        pattern: "baseValue",
        caseSensitive: !1
      }
    },
    isValid: !0
  },
  [d.START_WITH]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.STRING,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.Like,
      value: {
        "@type": i.PATTERN,
        pattern: "baseValue%",
        caseSensitive: !1
      }
    },
    isValid: !0
  },
  [d.EQUAL]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.NUMBER,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.EQ,
      value: {
        "@type": i.SCALAR,
        value: 23
      }
    },
    isValid: !0
  },
  [d.END_WITH]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.STRING,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.Like,
      value: {
        "@type": i.PATTERN,
        pattern: "%baseValue",
        caseSensitive: !1
      }
    },
    isValid: !0
  },
  [d.INCLUDE]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.STRING,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.Like,
      value: {
        "@type": i.PATTERN,
        pattern: "%baseValue%",
        caseSensitive: !1
      }
    },
    isValid: !0
  },
  [d.VALUE_SELECTION]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.STRING,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.IN,
      value: {
        "@type": i.DICT_ENTRIES,
        entries: [
          { id: "baseValue" }
        ]
      }
    },
    isValid: !0
  },
  [d.GREATER]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.NUMBER,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.GT,
      value: {
        "@type": i.SCALAR,
        value: 5
      }
    },
    isValid: !0
  },
  [d.GREATER_OR_EQ]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.NUMBER,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.GTE,
      value: {
        "@type": i.SCALAR,
        value: 5
      }
    },
    isValid: !0
  },
  [d.LOWER]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.NUMBER,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.LT,
      value: {
        "@type": i.SCALAR,
        value: 5
      }
    },
    isValid: !0
  },
  [d.LOWER_OR_EQ]: {
    type: i.dimension,
    dimensionCode: e.code,
    dataType: a.NUMBER,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.LTE,
      value: {
        "@type": i.SCALAR,
        value: 5
      }
    },
    isValid: !0
  },
  [d.BETWEEN]: {
    type: i.dimension,
    dataType: a.NUMBER,
    dimensionCode: e.code,
    reference: {
      id: e.alias,
      dimensionCode: e.alias,
      code: e.code,
      description: e.description,
      alias: e.alias
    },
    predicate: {
      negate: !1,
      operator: o.BETWEEN,
      value: {
        "@type": i.RANGE,
        minInclusive: 5,
        maxInclusive: 10
      }
    },
    isValid: !0
  }
}, X = {
  dimensionCode: e.code,
  type: i.dimension,
  predicate: {
    negate: !1,
    operator: o.IN,
    value: {
      "@type": i.DICT_ENTRIES,
      entries: [
        { id: "baseValue" }
      ]
    }
  }
}, Y = {
  dimensionCode: e.code,
  type: i.dimension,
  predicate: {
    negate: !1,
    operator: o.Like,
    value: {
      "@type": i.PATTERN,
      pattern: "%baseValue%",
      caseSensitive: !1
    }
  }
}, q = {
  initTimestamp: 0,
  filters: [],
  date: {
    name: "test",
    period: {
      id: -1,
      code: "",
      nameEN: "",
      nameFR: "",
      type: f.fixed,
      category: C.DAY,
      start: "2000-01-01",
      end: "2000-12-31",
      position: 0
    },
    start: m("2000-01-01"),
    end: m("2000-12-31")
  }
}, z = (t, s) => ({
  ...t,
  predicate: {
    ...t.predicate,
    value: {
      ...t.predicate.value,
      ...s
    }
  }
}), J = (t) => ({
  ...N.omit(t, [n[0].code, "metricCode"]),
  type: void 0
}), K = (t, s) => ({
  ...t,
  reference: {
    ...s
  }
}), Z = (t) => {
  const s = l.find((v) => v.metrics.find((E) => E.code === t.code));
  return {
    metricCode: t.code,
    metricAlias: t.alias,
    viewCode: (s == null ? void 0 : s.code) ?? "viewCode",
    viewAlias: (s == null ? void 0 : s.alias) ?? "viewAlias",
    additionalFilters: [],
    titlePartOverrides: {}
  };
}, ee = new A("fr", {
  fr: {
    hello: "bonjour"
  }
});
export {
  S as VIEW1_ALIAS,
  p as VIEW1_CODE,
  I as VIEW2_ALIAS,
  T as VIEW2_CODE,
  J as convertConfFilterToSelectorFilter,
  Z as convertMetricToMetricDef,
  z as copyFilterWithNewPredicate,
  K as copyFilterWithNewReference,
  n as dummyAvailableDimensions,
  h as dummyConfFilter,
  U as dummyConfMetric,
  q as dummyDataSelection,
  e as dummyDimension,
  V as dummyDimension2,
  g as dummyDimension3,
  j as dummyFilterByInputType,
  Y as dummyFilterLikeDtoDetail,
  X as dummyFilterValuesDtoDetail,
  ee as dummyLanguageResolver,
  k as dummyLikeFilter,
  B as dummyMetaModel,
  O as dummyMetaModelView,
  r as dummyMetric,
  c as dummyMetric2,
  w as dummyMetric3,
  x as dummyMetricDto,
  b as dummyMetricFilter,
  W as dummyMetricFilter2,
  $ as dummyPeriodFixed,
  Q as dummyRegexFilter,
  H as dummyValueSelectionFilter,
  l as dummyViews
};
//# sourceMappingURL=dummyModel.js.map
